'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'envelope-open-text';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f658';
var svgPathData = ['M64 200.4L239.3 334.8c8.4 6.4 17.7 11 27.5 13.7l1 .8c1.4 1.1 2.8 2.1 4.2 2.9l0 95.3-189.1 0C72.1 445.2 64 435.6 64 424l0-223.6z', 'M543.2 144c-2.3-12.4-9.5-23.4-20.2-30.5L332.4-13.6c-26.9-17.9-61.9-17.9-88.8 0L53 113.5c-12.9 8.6-20.8 23-21 38.5l0 272c0 30.9 24.9 56 55.9 56l184.1 0 0-32-184.1 0C74.7 448 64 437.3 64 424l0-223.6 175.3 134.4c9.9 7.6 21.1 12.5 32.7 14.9l0-33.1c-4.7-1.6-9.1-4-13.2-7.2L69.9 164.6c-3.7-2.9-5.9-7.3-5.9-12 0-5.1 2.5-9.8 6.7-12.6L261.4 13c16.1-10.7 37.1-10.7 53.3 0L505.3 140.1c1.6 1.1 2.9 2.4 4 3.9l33.9 0zM528 224c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l160 0zM368 192c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-160 0zm32 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faEnvelopeOpenText = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;